import { apiClient } from '../client';

export type ReportEntityType = 'user' | 'event' | 'space' | 'idea' | 'message';

export interface ReportReason {
  _id: string;
  key: string;
  displayName: string;
  types: ReportEntityType[];
  order: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateReportReasonRequest {
  key: string;
  displayName: string;
  types?: ReportEntityType[];
  order?: number;
  isActive?: boolean;
}

export interface UpdateReportReasonRequest {
  key?: string;
  displayName?: string;
  types?: ReportEntityType[];
  order?: number;
  isActive?: boolean;
}

export interface BulkUpdateOrderRequest {
  reasons: Array<{
    id: string;
    order: number;
  }>;
}

export const reportReasonsAPI = {
  // Get all report reasons (with optional inactive)
  getAllReportReasons: async (includeInactive = false): Promise<{ reasons: ReportReason[]; total: number }> => {
    const response = await apiClient.get(`/api/admin/report-reasons?includeInactive=${includeInactive}`);
    return response.data;
  },

  // Get active report reasons (public endpoint)
  getActiveReportReasons: async (): Promise<{ reasons: ReportReason[] }> => {
    const response = await apiClient.get('/api/admin/report-reasons/active');
    return response.data;
  },

  // Get report reason by ID
  getReportReasonById: async (id: string): Promise<{ reason: ReportReason }> => {
    const response = await apiClient.get(`/api/admin/report-reasons/${id}`);
    return response.data;
  },

  // Create new report reason
  createReportReason: async (data: CreateReportReasonRequest): Promise<{ reason: ReportReason; message: string }> => {
    const response = await apiClient.post('/api/admin/report-reasons', data);
    return response.data;
  },

  // Update report reason
  updateReportReason: async (id: string, data: UpdateReportReasonRequest): Promise<{ reason: ReportReason; message: string }> => {
    const response = await apiClient.put(`/api/admin/report-reasons/${id}`, data);
    return response.data;
  },

  // Delete (deactivate) report reason
  deleteReportReason: async (id: string, permanent = false): Promise<{ message: string; reason?: ReportReason }> => {
    const response = await apiClient.delete(`/api/admin/report-reasons/${id}?permanent=${permanent}`);
    return response.data;
  },

  // Bulk update order
  bulkUpdateOrder: async (data: BulkUpdateOrderRequest): Promise<{ message: string }> => {
    const response = await apiClient.put('/api/admin/report-reasons/bulk/update-order', data);
    return response.data;
  },
};
